<template>
    <div id="convertConsultanttoREP" class="modal fade" role="dialog">
      <div class="modal-dialog">
        <div class="modal-content first-modal-content p-15">
          <div class="modal-header deactiveModal-bgcolor">
            <button type="button" class="close" data-toggle="modal" data-target="#convertConsultanttoREP">&times;</button>
          </div>
          <div class="modal-body desc-text p-0 pt-15 pb-15">
            <div class="align-right">
              <el-popover
                  popper-append-to-body="false"
                  placement="bottom-end"
                  class="info-icon-class"
                  trigger="click"
                  popper-class="popup-background tootip-custom-small-width-class"
                  @show="infoActive = true"
                  @hide="infoActive = false"
                >
                  <div class="content">
                    By converting a user profile from "Consultant" to "REP Consultant", the user will:
                    <ul>
                      <li>Get access to all RAMS representation accounts.</li>
                      <li>Lose access to already assigned Accounts(Other than REP Accounts).</li>
                      <li>Lose access to already assigned Smart Builder projects.</li>
                    </ul>
                  </div>
                  <img
                    class="info-img"
                    src="/static/images/icons/info_icon.svg"
                    v-if="!infoActive"
                    alt="info-icon"
                    slot="reference"
                  />
                  <img
                    class="info-img"
                    src="/static/images/icons/info_icon_active.svg"
                    v-if="infoActive"
                    alt="infoactive-icon"
                    slot="reference"
                  />
              </el-popover>
            </div>
            <div class="title-text center">Are you sure you would like to convert the below Consultant to REP Consultant?
                <div class="bold-text">{{convertUserDetails.first_name}} {{convertUserDetails.last_name}}</div>
            </div> 
          </div>
          <div class="modal-footer deactiveModal-bgcolor pl-0 pr-0">
            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 mr-tp-10">
              <button
                class="btn btn-block emergo-white-button"
                data-toggle="modal"
                data-target="#convertConsultanttoREP"
              >Cancel</button>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 mr-tp-10">
              <button
                class="btn btn-block emergo-blue-button"
                @click="convertConsultanttoREP"
              >Convert</button>
            </div>
          </div>
          <loader :loadingStatus="loaderStatus"></loader>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import $ from 'jquery';
  import { Popover } from 'element-ui';
  import Loader from '../UIComponents/Loader.vue';
  import { convertConsultantToRepConsultant } from '../../apis/repRoles';
  
  export default {
    props: ['convertUserDetails'],
    data() {
      return {
        loaderStatus: false,
        loadedUser: true,
        infoActive: false
      };
    },
    components: {
      Loader,
      'el-popover': Popover
    },
    methods: {
      async convertConsultanttoREP() {
        this.loaderStatus = true;
        const respData = await convertConsultantToRepConsultant({ user_id: this.convertUserDetails.user_id });
        if (respData && respData.message === 'success') {
          setTimeout(() => {
            this.loaderStatus = false;
            this.$emit('converted');
            this.clearNotifications();
            this.$notify({
              type: 'success',
              title: 'Success',
              text: respData.data,
              group: 'custom-notification',
            });
            $('#convertConsultanttoREP').modal('hide');
          },1000);
        } else {
          this.loaderStatus = false;
          this.clearNotifications();
          this.$notify({
            type: 'error',
            title: 'Error',
            text: 'Unable to convert Consultant!',
            group: 'custom-notification',
          });
        }
      },
      clearNotifications() {
        this.$notify({
          clear: true,
          group: 'custom-notification',
        });
      },
    },
  };
  </script>
  <style lang="scss" scoped>
  .search {
    .search-input {
      padding-left: 35px;
      width: 100%;
    }
    position: relative;
    > i.fa-search {
      position: absolute;
      top: 11px;
      left: 15px;
    }
    span.search-reset {
      top: 5px;
      right: 10px;
      font-size: 17px;
    }
  }
  .float-rt {
    float: right;
  }
  .mr-tp-10{
    margin-top: 10px;
  }
  .modal-header .close {
    background: none;
    opacity: 0.5;
    height: 17px;
    line-height: 17px;
    color: #828282;
    width: 17px;
    border-radius: 20px;
    font-weight: 300;
    outline: none;
    font-size: 32px;
  }
  .modal-header{
      padding:0;
  }
  .modal-title{
      padding:15px;
  }
  .modal-header.deactiveModal-bgcolor {
    background-color: $white;
    border: 0px;
    border-radius: $radius10;
  }
  .confirm-body {
    padding: 5% 12%;
    margin-bottom: 10%;
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    text-align: center;
    color: $black-alpha2;
  }
  .modal-content.first-modal-content {
    border-radius: $radius12;
  }
  .title-text {
    font-size: $font-18;
    color: $black-alpha2;
    padding-top: 10px;
    line-height: 24px;
  }
  .bold-text {
    font-size: $font-24;
    line-height: 28px;
    font-weight: $font-weight-medium;
    text-align: center;
    color: $primary;
    padding-top: 10px;
  }
  .desc-text {
    font-weight: $font-weight-medium;
    font-size: $font-16;
    line-height: 19px;
    color: $black-alpha2;
    text-align: left;
    margin: 20px;
  }
  .modal-footer.deactiveModal-bgcolor {
    background-color: $white;
    border: 0px;
    border-radius: $radius10;
    padding-bottom: 32px;
  }
  div#deactiveModal {
    background-color: rgba(0, 0, 0, 0.5);
  }
  .modal-header.upgradeModal-bgcolor {
    background-color: $white;
    border: 0px;
    border-radius: $radius10;
  }
  .selected-names {
    background: rgba(201, 226, 244, 0.5);
    border-radius: 28px;
    padding: 8px 15px 8px 17px;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    color: $primary;
    margin-right: 10px;
    margin-bottom: 10px;
    display: inline-block;
  }
  .info-img {
    width: 18px;
    height: 18px;
  }
  .el-popover {
    .content {
      margin-left: 15px;
      margin-right: 10px;
      font-style: normal;
      font-weight: $font-weight-400;
      font-size: $font-16;
      line-height: 24px;
      color: $dark-black-alpha;
      text-align: left;
      word-break: break-word;
      ul {
        padding-bottom: 20px;
        padding-left: 20px;
        li {
          &:not(:first-child) {
            padding-top: 5px;
          }
        }
      }
    }
  }
  </style>
  